import { render, staticRenderFns } from "./ConfirmUnbanWowStreamer.vue?vue&type=template&id=172caade&scoped=true"
import script from "./ConfirmUnbanWowStreamer.vue?vue&type=script&lang=js"
export * from "./ConfirmUnbanWowStreamer.vue?vue&type=script&lang=js"
import style0 from "./ConfirmUnbanWowStreamer.vue?vue&type=style&index=0&id=172caade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172caade",
  null
  
)

export default component.exports